import { useEffect } from 'react';
import { useIsMobile } from '@sravni/react-utils';

function useMobileForm(dialogContentRef) {
    const isMobile = useIsMobile();
    useEffect(() => {
        if (!window.visualViewport) {
            return;
        }
        document.ontouchmove = function (e) {
            e.preventDefault();
        };
        const resizeFunction = () => {
            if (dialogContentRef.current && window.visualViewport && isMobile) {
                dialogContentRef.current.style.height = `${window.visualViewport.height}px`;
            }
        };
        window.visualViewport.addEventListener('resize', resizeFunction);
        return () => {
            if (!window.visualViewport) {
                return;
            }
            window.visualViewport.removeEventListener('resize', resizeFunction);
        };
    }, [dialogContentRef, isMobile]);
}

export { useMobileForm };
//# sourceMappingURL=useMobileForm.js.map
